import { render } from "./WeddingKioskFormType3.vue?vue&type=template&id=4f646811&lang=true"
import script from "./WeddingKioskFormType3.vue?vue&type=script&lang=js"
export * from "./WeddingKioskFormType3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__